import { useState, useEffect } from 'react';
import apiClient from '../../apiClient';
import {
    Button,
    TextField,
    Box,
    Stack,
    Divider,
    Typography,
    FormControl
} from '@mui/material';
import { SelectGenericFromTable, GetPersisterConfigFile } from '../universal/Axios';
import { HandleAuthError, GenericStackTraceValidator } from '../universal/Alert';
import { getStore } from '../../Store'
import { IsJsonString } from '../universal/JSONHelper';
const store = getStore();


const UploadPersisterConfig = () => {
    const [isSubmitButtonDisabled, setSubmitButtonDisabled] = useState(true);
    const [id, setID] = useState("");
    const [existingIDs, setExistingIDs] = useState([])
    const [fileContent, setFileContent] = useState("");
    const [errorMessages, setErrorMessages] = useState({});
    
    useEffect(() => {
        SelectGenericFromTable("select id from persister_config;", setExistingIDs)
    }, []);


    useEffect(() => {
        validateForm()
    }, [id, fileContent])

    useEffect(() => {
        checkSubmitButtonDisabled()
    }, [errorMessages])

    const uploadPersisterConfig = () => {
        apiClient.post(
            "https://us-central1-airy-semiotics-297902.cloudfunctions.net/interactive-density-network",
            {
                "function_to_execute": "Upload_Persister_Config",
                "id": id,
                "file_content": JSON.parse(fileContent),
            }
        ).then(({ data }) => {
            store.updateSuccessMessage("Successfully created Persister Config!")
            window.location.href = "persister-configs"
        }).catch(function (error) {
            if (error?.response?.status === 401) {
                HandleAuthError()
            } else {
                const stackTraceMessage = GenericStackTraceValidator(error?.response?.data, "Density Network Config")
                if (stackTraceMessage != null) {
                    store.updateErrorMessage(stackTraceMessage)
                } else {
                    store.updateErrorMessage("Error while creating heat map")
                }
            }
        })
    }

    const validateForm = () => {
        //ID Section
        if (existingIDs.map(x => x["id"]).indexOf(id) === -1) {
            setErrorMessages(errorMessages => ({ ...errorMessages, ["uniqueness"]: "" }))
        }
        else {
            setErrorMessages(errorMessages => ({ ...errorMessages, ["uniqueness"]: "A persister config with that ID already exists" }))
        }

        if (id === "") {
            setErrorMessages(errorMessages => ({ ...errorMessages, ["has_id"]: "No ID" }))
        }
        else {
            setErrorMessages(errorMessages => ({ ...errorMessages, ["has_id"]: "" }))
        }

        //File Content Section
        if (fileContent === "") {
            setErrorMessages(errorMessages => ({ ...errorMessages, ["has_file_content"]: "No file content" }))
        }
        else {
            setErrorMessages(errorMessages => ({ ...errorMessages, ["has_file_content"]: "" }))
        }

        if (!IsJsonString(fileContent)) {
            setErrorMessages(errorMessages => ({ ...errorMessages, ["is_valid_json"]: "File Content is not valid JSON" }))
        }
        else {
            setErrorMessages(errorMessages => ({ ...errorMessages, ["is_valid_json"]: "" }))
        }
    }

    const checkSubmitButtonDisabled = () => {

        const has_errors = Object.keys(errorMessages).map(x => errorMessages[x]).some(x => x !== "")
        setSubmitButtonDisabled(has_errors)
    }

    return (
        <Box>
            <Typography sx={{ marginBottom: '20px' }} variant="h6">Upload Persister Config</Typography>
            <Box sx={{ m: 2 }}>
                <FormControl fullWidth>
                    {errorMessages["has_id"] !== undefined && <Typography color="red">{errorMessages["has_id"]}</Typography>}
                    {errorMessages["uniqueness"] !== undefined && <Typography color="red">{errorMessages["uniqueness"]}</Typography>}
                    <TextField
                        id="id"
                        label="ID"
                        variant="outlined"
                        multiline
                        value={id}
                        maxRows={5000}
                        onChange={(event) => setID(event.target.value)}
                        helperText={errorMessages.id}
                        sx={{ marginBottom: '10px' }}
                    />
                    {errorMessages["has_file_content"] !== undefined && <Typography color="red">{errorMessages["has_file_content"]}</Typography>}
                    {errorMessages["is_valid_json"] !== undefined && <Typography color="red">{errorMessages["is_valid_json"]}</Typography>}
                    <TextField
                        id="file_content"
                        label="File Content"
                        variant="outlined"
                        multiline
                        rows={10}
                        value={fileContent}
                        maxRows={5000}
                        onChange={(event) => setFileContent(event.target.value)}
                        helperText={errorMessages.id}
                    />
                </FormControl>
            </Box>
            <Divider />
            <Box sx={{ m: 2 }}>
                <Stack direction="row" spacing={1} justifyContent="flex-end">
                    <Button href={"persister-configs"}>Cancel</Button>
                    <Button
                        variant="contained"
                        onClick={() => uploadPersisterConfig()}
                        disabled={isSubmitButtonDisabled}
                    >
                        Submit
                    </Button>
                </Stack>
            </Box>
        </Box>
    )
}

export default UploadPersisterConfig;